import { Alert, Stack, Typography, type AlertProps } from '@mui/material'
import { PropsWithChildren } from 'react'
import { pickChildrenByType } from '../../utils/childrenPickers'

const Title = ({ children }: { children: React.ReactNode }) => {
  return <Typography variant="subtitle2">{children}</Typography>
}

const Description = ({ children }: { children: React.ReactNode }) => {
  return <Typography variant="caption">{children}</Typography>
}

const Body = ({ children }: { children: React.ReactNode }) => {
  return <>{children}</>
}

export type MonitoringAlertProps = PropsWithChildren<AlertProps>

export const MonitoringAlert: React.FC<MonitoringAlertProps> & {
  Title: React.FC<PropsWithChildren<{ children: React.ReactNode }>>
  Description: React.FC<PropsWithChildren<{ children: React.ReactNode }>>
  Body: React.FC<PropsWithChildren<{ children: React.ReactNode }>>
} = ({ children, ...props }) => {
  const titleElements = pickChildrenByType(children, Title)
  const descriptionElements = pickChildrenByType(children, Description)
  const bodyElements = pickChildrenByType(children, Body)
  return (
    <Alert severity="warning" sx={{ width: '100%' }} variant="filled" {...props}>
      <Stack direction="column" spacing={1}>
        {titleElements}
        {descriptionElements}
        {bodyElements}
      </Stack>
    </Alert>
  )
}

MonitoringAlert.Title = Title
MonitoringAlert.Description = Description
MonitoringAlert.Body = Body
